var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.user.role == '模具买家')?_c('div',[_c('p',[_vm._v("当前身份为模具买家无法创建工厂")])]):_c('div',[(_vm.count == 0)?_c('div',[_c('p',[_vm._v("当前账号没有创建工厂")]),_c('router-link',{attrs:{"tag":"a","to":{
                name:'CreateFactory',
            }}},[_c('el-button',[_vm._v("立即创建")])],1)],1):_c('div',[_c('p',[_vm._v(_vm._s(_vm.factory.factory_name))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }